<sn-drawer>
  <sn-drawer-header title="LVT">
    <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
  </sn-drawer-header>

  <sn-drawer-content>
    <mat-list>
      <mat-list-item>
        <mat-icon matListItemIcon>dvr</mat-icon>
        <span class="unit-name-col">
          <h5 matListItemTitle>Unit Name:</h5>
          <h4 matListItemLine>{{ lvtCam.liveUnitName }}</h4>
        </span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>my_location</mat-icon>
        <span class="coordinates-col">
          <h5 matListItemTitle>Coordinates:</h5>
          <h4 matListItemLine>[{{ lvtCam.coordinates[1] | fsNumber : '1.6-6' }}, {{ lvtCam.coordinates[0] | fsNumber : '1.6-6' }}]</h4>
        </span>
      </mat-list-item>
      <mat-list-item>
        <mat-form-field class="button-dropdown">
          <mat-select
            placeholder="Play Sound"
            name="soundSelect"
            (selectionChange)="playSound(soundSelect)"
            [(ngModel)]="soundSelect"
          >
            <mat-option *ngFor="let sound of soundList" [value]="sound">{{
              sound.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="button-dropdown">
          <mat-select
            placeholder="Toggle Lights"
            name="lightSelect"
            (selectionChange)="playLight(lightSelect)"
            [(ngModel)]="lightSelect"
            multiple
          >
            <mat-option *ngFor="let light of lightList" [value]="light">{{
              light.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-list-item>
    </mat-list>

    <div
      id="lvt-{{ lvt.id }}"
      class="not-see-through card-camera"
      *ngFor="let lvt of lvtCams; trackBy: trackCam"
    >
      <fs-lvt-feed-card
        [lvt]="lvt"
        [headers]="headers"
        [soundList]="soundList"
        [lightList]="lightList"
        [isOnMap]="true"
      ></fs-lvt-feed-card>
    </div>
  </sn-drawer-content>
</sn-drawer>
